import { useCartModal } from "@/features/cart/CartModal";
import { useTranslations } from "@/i18n/client";
import type { ProductDetails } from "@/lib/centra";
import { useBuyBox as useCentraBuyBox } from "@frend-digital/centra/client";
import { useEffect } from "react";
import { useUrlSearchParams } from "@frend-digital/ui/next";

export const useBuyBox = (sizes: ProductDetails["items"]) => {
	const [, setOpen] = useCartModal();
	const t = useTranslations();
	const searchParams = useUrlSearchParams();

	useEffect(() => {
		if (sizes?.length === 1 && !searchParams.get("size")) {
			const singleSize = sizes[0];
			const newParams = new URLSearchParams(searchParams.toString());
			newParams.set("size", singleSize?.name!);
			window.history.replaceState({}, "", `?${newParams.toString()}`);
		}
	}, [sizes, searchParams]);

	return useCentraBuyBox({
		sizes,
		labels: {
			add_to_cart: t("Add to cart"),
			coming_soon: t("Coming soon"),
			out_of_stock: t("Notify me"),
			preorder: t("Preorder"),
			select_size: t("Select size"),
		},
		onSuccess() {
			setOpen(true);
		},
	});
};

export type UseBuyBoxReturn = ReturnType<typeof useBuyBox>;
